<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [title]="'Campaigns'"
      [class]="extraClass"
      [canGoBack]="false" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [isPrimaryLayer]="true" [hasBottomNav]="!windowService.isDesktopRes">
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    @if (windowService.isDesktopRes) {
      <tidy-desktop-header>
        <div class="wrappable-container">
          <tidy-text
            [title]="'Campaigns'" />
          <tidy-image
            [src]="'assets/img/download_csv.svg'"
            class="desktop-header-icon secondary-text-icon"
            (action)="exportCSV()" />
        </div>
      </tidy-desktop-header>
    }

    <!-- Skeleton table while loading — rows float in with the entrance cascade;
         the real table below then replaces it in place, instantly (skipEntrance). -->
    @if (!loaded) {
      <tidy-table
        [skeletonLoading]="true"
        [columnslabels]="headers" />
    }

    @if (loaded) {
      <tidy-row>
        <tidy-text
          [body]="'Set up your campaigns.'" />
      </tidy-row>
      <tidy-row>
        <tidy-table
          #tidyTable
          [dataSource]="rows"
          [displayedColumns]="headers"
          [columnslabels]="headers"
          [skipEntrance]="true" />
      </tidy-row>
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'Talk to your account manager about starting a new campaign.'" />
      </tidy-row>
    }
  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [isfullWidthContent]="true" [templateContent]="content" [desktopWidthContent]="desktopWidthContent" />
